/**
 * Evidencing & Monitoring (Stage 8) workflow call-to-action by role. Kept dependency-free so the persona
 * gates are unit-testable without mounting the antd / MSAL surface of EvidencingMonitoring.jsx.
 *
 * Hand-off submits stay open to platform_admin (the API allows them); approve / publish / finalize do not:
 * the API answers platform_admin 403 PLATFORM_ADMIN_APPROVAL_DENIED (PRD s2.2), so no button is offered.
 * The UI gate is a convenience only - the API is the enforcement.
 */
import { Role } from "../constants/roles";

// platform_admin is excluded from approve_send_to_la / publish: the API answers 403 PLATFORM_ADMIN_APPROVAL_DENIED (PRD s2.2).
export function getIncidentCta(role, workflow) {
  if (workflow === "not_started" && (role === Role.LEAD_ADVISOR || role === Role.ADMIN)) {
    return { action: "push_to_spoc", label: "Push to SPOC" };
  }
  if (workflow === "pushed_to_spoc" && (role === Role.COMPANY_SPOC || role === Role.ADMIN)) {
    return { action: "submit_to_delegate", label: "Submit to Delegate" };
  }
  if (workflow === "delegate_review" && (role === Role.COMPANY_DELEGATE || role === Role.ADMIN)) {
    return { action: "submit_to_advisor", label: "Submit to Advisor" };
  }
  if (workflow === "advisor_review" && (role === Role.ADVISOR || role === Role.LEAD_ADVISOR || role === Role.ADMIN)) {
    return { action: "submit_for_spoc_approval", label: "Submit for SPOC Approval" };
  }
  if (workflow === "spoc_final_approval" && role === Role.COMPANY_SPOC) {
    return { action: "approve_send_to_la", label: "Approve & Send to Lead Advisor" };
  }
  if (workflow === "la_publish" && role === Role.LEAD_ADVISOR) {
    return { action: "publish", label: "Publish" };
  }
  if (workflow === "published" && (role === Role.LEAD_ADVISOR || role === Role.ADMIN)) {
    return { action: "restart", label: "Start New Version" };
  }
  return null;
}

// platform_admin is excluded from finalize (403 PLATFORM_ADMIN_APPROVAL_DENIED).
export function getEvidenceCta(role, workflow) {
  if (workflow === "not_started" && (role === Role.LEAD_ADVISOR || role === Role.ADMIN)) {
    return { action: "push_to_spoc", label: "Push to SPOC" };
  }
  if (workflow === "pushed_to_spoc" && (role === Role.COMPANY_SPOC || role === Role.ADMIN)) {
    return { action: "submit_to_delegate", label: "Submit to Delegate" };
  }
  if (workflow === "delegate_review" && (role === Role.COMPANY_DELEGATE || role === Role.ADMIN)) {
    return { action: "submit_to_advisor", label: "Submit to Advisor" };
  }
  if (workflow === "advisor_review" && (role === Role.ADVISOR || role === Role.LEAD_ADVISOR || role === Role.ADMIN)) {
    return { action: "submit_for_finalization", label: "Submit for Finalization" };
  }
  if (workflow === "spoc_finalize" && role === Role.COMPANY_SPOC) {
    return { action: "finalize", label: "Finalize" };
  }
  return null;
}
